import axios from "axios";
import { API_BASE_URL } from "./config";

/** Axios client without auth interceptors — for public endpoints. */
export const publicApi = axios.create({
  baseURL: API_BASE_URL,
});
